/**
 * @flow
 */

import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import type {Store, MyDispatch, Action} from "../actions/types.js";
import actions from "../actions";
import * as api2 from "../api2";
import * as types from "../actions/types";
import MyComponent, {type Props} from "../components/TradingViewChartStopOrderLine";
import {buildOrderBook, buildOpenOrdersInfo} from "../lib/ByBitUtils";

type OwnProps = {|
  tvWidget: any,
  order: types.bybitws.StopOrder,
|};

const connector = connect<Props, OwnProps, _, _, _, _>(
  (store: Store, ownProps: OwnProps) => ({}),
  (dispatch: MyDispatch, ownProps: OwnProps) => ({
    cancelStopOrder: bindActionCreators(
      actions.bybit.cancelStopOrder,
      dispatch,
    ),
    replaceStopOrder: bindActionCreators(
      actions.bybit.replaceStopOrder,
      dispatch,
    ),
  }),
);

const Connected: * = connector(MyComponent);
export default Connected;

function test(props: OwnProps) {
  return <Connected {...props} />;
}
